export default {
    success: {},
    error: {
      username: "*Username is Required",
      enter_password: "*Password is Required",
      confirm_password: "Password Field is Empty",
      password_mismatch:"Password doesn't not match",
      rangeName: "Range name field is required",
      rangeNameLenErr:"Minimum 3 characters required",
      phone: "Enter a valid phone number",
      address1: "Address field is required",
      address2: "Address Field is required",
      state:"Please select a state",
      city: "Please enter a city",
      country: "Please select a country",
      latitude: "Latitude field is required",
      longitude: "Longitude field is required",
      zip: "length must be between 0 and 10"
    },
    warn: {
      required: "Please select a country"
    },
    info: {},
  };
  